var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Laag_1",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 900 900"
    },
    xmlSpace: "preserve",
    viewBox: "256.55 235.93 384.56 427.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000051370751235055190140000012180135033818866597_);}\n\t.st2{fill:url(#SVGID_00000123399747089992510340000012428949127338076602_);}\n\t.st3{opacity:0.28;fill:url(#SVGID_00000125605139001680683760000016461328897748213637_);}\n\t.st4{opacity:0.28;fill:url(#SVGID_00000098209278262006046300000008766289085386954135_);}\n\t.st5{opacity:0.13;fill:url(#SVGID_00000033364380640378343870000000122718615581353371_);}\n\t.st6{opacity:0.36;fill:url(#SVGID_00000173159779355753202850000014727187067555239595_);}\n\t.st7{opacity:0.5;fill:url(#SVGID_00000160174747767820068140000014199249068991432343_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 43.7511,
    y1: 444.1792,
    x2: 43.7511,
    y2: 687.8558,
    gradientTransform: "matrix(-1 0 -0.2105 1.0465 551.9504 -24.5903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009CFF"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M298.51,629.96c20.61,15.7,39.89,21.88,50.96,25.27c20.91,6.39,37.5,7.18,48.55,7.62   c18.76,0.76,29.29-1.37,34.41-2.6c2.26-0.54,9.29-2.31,17.43-5.8c36.67-15.73,55.84-49.3,58.22-53.59   c6.46-11.65,9.65-21.28,12.03-30.03c5.5-20.25,8.34-41.81,7.95-64.19l-2.3-119.49c-0.17-9.22,6.51-16.78,14.81-16.78h-2.54   c-15.75,1.17-27.19,5.76-33.78,8.99c-29.69,14.58-50.44,45.59-52.47,77.56c-0.63,9.95,0.67,18.08,1.72,22.98   c-29.28,48.16-57.3,78.6-64.98,79.05c-0.51,0.03-5.22,0.18-10.73,0.02c-2.87-0.09-5.82-0.27-9.47-0.91   c-0.2-0.04-0.38-0.07-0.54-0.1c-2.16-0.42-6.02-1.18-10.59-3.22c-5.24-2.35-8.73-5.17-10.78-6.85c-6.5-5.34-19.26-20.8-22.98-22.21   c-8.22-3.11-64.27,33.31-66.29,40.91c-2.62,9.91,3.82,19.68,12.26,32.49C278.61,613.06,289.22,622.88,298.51,629.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000030466520516192714090000003540794296568519304_",
    gradientUnits: "userSpaceOnUse",
    x1: -19.1462,
    y1: 603.3702,
    x2: -97.6862,
    y2: 292.6454,
    gradientTransform: "matrix(-1 0 0 1 442.6138 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000030466520516192714090000003540794296568519304_)"
    },
    d: "M388.5,558.95   c7.71-0.14,22.37-1.59,36.34-11.22c32.07-22.12,28.85-65.58,28.64-67.83l0.46-21.04c1.34-46.11,43.14-88.47,87.22-88.47h6.52   c1.59,0,3.14-0.14,4.72-0.21v0.11h88.7v-75.5c0-32.49-25.97-58.84-58.01-58.84h-41.51c-78.55,0-141.28,67.88-139.87,151.21   c0,0,2.55,137.85,1.83,144.64c-0.36,3.38-0.95,5.71-1.09,6.25c-0.77,2.96-1.75,5.25-2.63,7.29c-0.52,1.21-1.24,2.8-2.21,4.64   c-0.99,1.87-1.48,2.8-2.27,3.83c-1.8,2.34-3.62,3.52-4.07,3.8C390.2,558.28,389.21,558.69,388.5,558.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000158708498297259121370000012095429961633031088_",
    gradientUnits: "userSpaceOnUse",
    x1: 158.2654,
    y1: 307.3103,
    x2: -16.9892,
    y2: 311.7633,
    gradientTransform: "matrix(-1 0 0 1 442.6138 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00CB38"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#009CFF"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000158708498297259121370000012095429961633031088_)"
    },
    d: "M285.73,278.4v91.98h103.86   c1.2,0,2.4,0.18,3.49,0.54c4.86,1.57,8.46,6.36,8.56,12.01l0.04,1.39c0-51.76,24.81-97.2,62.59-123.76   c-10.82-7.61-22.7-13.62-35.31-17.8c-13.18-4.43-27.17-6.83-41.66-6.83h-59.7c-0.78,0-1.55,0.04-2.33,0.07   C303.25,237.22,285.73,255.74,285.73,278.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000123407540512800141760000008259189609626993058_",
    gradientUnits: "userSpaceOnUse",
    x1: 29.7096,
    y1: 430.7949,
    x2: 84.3704,
    y2: 201.0719,
    gradientTransform: "matrix(-1 0 -0.2105 1.0465 551.9504 -24.5903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.28,
      fill: "url(#SVGID_00000123407540512800141760000008259189609626993058_)"
    },
    d: "M393.1,370.92   c4.84,1.58,8.43,6.35,8.54,12l0.08,4.22c-0.9-52.93,24.1-99.56,62.56-126.58c-10.81-7.6-22.71-13.63-35.33-17.8   C414.21,266.87,390.37,315.12,393.1,370.92z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140720264679350884040000017425599743230199429_",
    gradientUnits: "userSpaceOnUse",
    x1: -40.8159,
    y1: 591.5574,
    x2: 21.6076,
    y2: 329.21,
    gradientTransform: "matrix(-1 0 -0.2105 1.0465 551.9504 -24.5903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.28,
      fill: "url(#SVGID_00000140720264679350884040000017425599743230199429_)"
    },
    d: "M388.5,558.95   c7.71-0.14,22.37-1.58,36.34-11.22c32.08-22.12,28.84-65.6,28.64-67.84l0.47-21.04c1.33-46.12,43.13-88.48,87.23-88.48   c0,0-80.55-5.75-99.6,83.06c-4.13,19.23-5.77,34.57-19.56,48.45c-6.48,6.53-13.48,10.2-18.39,12.29c0.08,6.24,0.08,9.1,0.06,10.52   c-0.01,0.88-0.05,2.73-0.05,4.05c0,0.16,0,0.74-0.01,1.53c-0.01,0.27-0.02,0.72-0.03,1.08c-0.04,0.79-0.13,1.42-0.28,2.28   c-0.31,1.83-0.46,2.75-0.74,3.87c-0.29,1.15-0.56,2-0.8,2.74c-0.25,0.77-1.32,4-3.61,8.72c-0.33,0.68-0.5,1.01-0.68,1.37   c0,0-1.9,3.74-4.37,5.87c-0.79,0.68-1.65,1.24-1.65,1.24C390.76,557.89,389.78,558.45,388.5,558.95z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000050641649532449279690000000781975848934574208_",
    gradientUnits: "userSpaceOnUse",
    x1: 24.3057,
    y1: 695.3127,
    x2: -111.9117,
    y2: 353.4339,
    gradientTransform: "matrix(-1 0 -0.2105 1.0465 551.9504 -24.5903)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.13,
      fill: "url(#SVGID_00000050641649532449279690000000781975848934574208_)"
    },
    d: "M429.7,660.63   c7.19-1.56,17.1-4.46,27.94-10.14c2.2-1.15,10.94-5.82,20.97-14.24c3.24-2.72,17.29-14.8,28.53-34.19   c3.92-6.75,6.39-12.48,7.31-14.68c1.05-2.52,3.21-7.92,5.72-17.02c1.51-5.47,4.37-16.76,6.2-31.71c1.06-8.69,1.89-19.52,1.68-32.02   c-0.77-39.83-1.54-79.66-2.3-119.49c-0.11-0.89-0.74-6.89,3.73-11.85c4.35-4.82,10.16-4.93,11.08-4.93h-2.66   c-12.23,0-24.31,3.24-35.36,8.99c-11.89,26.26-16.62,54.04-13.38,79.75c5.47,43.34,5.22,72.14-0.21,97.61   c-4.77,22.4-12.32,39.12-16.48,47.42C458.86,631.31,441.57,649.76,429.7,660.63z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054267689390743429780000018199742148129827240_",
    gradientUnits: "userSpaceOnUse",
    x1: -71.9518,
    y1: 162.7933,
    x2: -181.5604,
    y2: 332.7663,
    gradientTransform: "matrix(-1 0 0 1 442.6138 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.36,
      fill: "url(#SVGID_00000054267689390743429780000018199742148129827240_)"
    },
    d: "M595.61,370.28h45.5v-75.5   c0-17.84-7.82-33.82-20.19-44.61c-10.15-8.87-23.37-14.23-37.81-14.23h-18.47C581.34,252.34,603.72,289.88,595.61,370.28z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000006672180202731001750000003441775164866471866_",
    gradientUnits: "userSpaceOnUse",
    x1: -121.787,
    y1: 210.1803,
    x2: -201.2437,
    y2: 333.3961,
    gradientTransform: "matrix(-1 0 0 1 442.6138 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "url(#SVGID_00000006672180202731001750000003441775164866471866_)"
    },
    d: "M634.17,370.28h6.94v-75.5   c0-17.84-7.82-33.82-20.19-44.61C628.78,270.11,636.74,306.47,634.17,370.28z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.7b321c655101a756489eb37930610f9f.svg";
export { ForwardRef as ReactComponent };